import Vue from 'vue'
import App from './App.vue'
import ElementUI from "element-ui";
import router from "./router";
import VueRouter from "vue-router";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/common.scss";
import axios from "axios";
// import VueAxios from "vue-axios";

// Vue.use( );
Vue.use(ElementUI);
Vue.use(VueRouter);

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  console.log(to, from, next);
  // console.log(1111);
  window.scrollTo(0, 0);
});
new Vue({
  render: (h) => h(App),
  router,
  axios,
}).$mount("#app");
